import HttpErrorScreen from 'epic-fortnite-react/components/error/HttpErrorScreen';
import {getInitialCmsPageSharedValues, PageData, useCmsData} from 'epic-fortnite-shared-values';
import React from 'react';
import Helmet from 'react-helmet';
import {sanitizeCopy} from '@epic-mw/common-utils/dist/contentUtils';

import LoadScreen from '../../components/loadScreen/LoadScreen';

interface SafetySecurityPageData extends PageData {
  content?: string;
  image?: string;
  metaTitle?: string;
  metaDescription?: string;
  metaImage?: string;
}

/**
 * Safety and Security View
 */
const SafetySecurityView = () => {
  const {
    pageData: data,
    isLoading,
    error,
  } = useCmsData<SafetySecurityPageData>('/safety-and-security');

  if (isLoading) {
    return <LoadScreen show={true} />;
  }

  if (error) {
    return <HttpErrorScreen statusCode={error.response?.status ?? 500} />;
  }

  if (!data) {
    return <HttpErrorScreen statusCode={404} />;
  }

  const {content, image, metaTitle, metaDescription, metaImage} = data;
  const style = {
    backgroundImage: `url(${image})`,
  };
  const tags = [
    {itemProp: 'name', content: metaTitle},
    {itemProp: 'description', content: metaDescription},
    {itemProp: 'image', content: metaImage},
    {name: 'description', content: metaDescription},
    {name: 'twitter:title', content: metaTitle},
    {name: 'twitter:description', content: metaDescription},
    {name: 'twitter:image', content: metaImage},
    {property: 'og:title', content: metaTitle},
    {property: 'og:image', content: metaImage},
    {property: 'og:description', content: metaDescription},
  ];

  return (
    <div className="safetySecurityView">
      {
        // only override default meta if there is meta data in CMS
        metaTitle && <Helmet meta={tags} title={metaTitle} />
      }
      <div className="header-image" style={style} />
      <div className="content" dangerouslySetInnerHTML={{__html: sanitizeCopy(content ?? '')}} />
    </div>
  );
};

SafetySecurityView.getInitialSharedValues = getInitialCmsPageSharedValues('/safety-and-security');

export default SafetySecurityView;
